var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"inline"},_vm._l((_vm.orientations),function(orientation,index){return _c(_vm.getElementType(orientation),_vm._b({key:index,tag:"component"},'component',_vm.getElementAttrs(orientation),false),[_vm._v(_vm._s(orientation.text))])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }